// src/components/GuideSection.js
import React, { useState } from 'react';
import { COLORS } from '../theme';

const GuideSection = ({ appConfig }) => {
    // 設定値の取得 (未設定時のデフォルト値も指定)
    const pointName = appConfig?.pointNameLabel || 'RB Coin';

    // OS切り替え用タブのState
    const [osTab, setOsTab] = useState('ios'); // 'ios' or 'android'

    // 解説用のマーカーコンポーネント
    const Marker = ({ num }) => <span className="guide-marker" style={{ background: COLORS.primary, color: 'white', borderRadius: '50%', padding: '2px 6px', fontSize: '10px', fontWeight: 'bold' }}>{num}</span>;

    // スタイリッシュなステップ表示用コンポーネント
    const StepItem = ({ step, title, children, isLast }) => (
        <div style={{ display: 'flex', marginBottom: isLast ? '0' : '20px', position: 'relative' }}>
            {!isLast && <div style={{ position: 'absolute', top: '30px', left: '15px', bottom: '-20px', width: '2px', background: '#e0e0e0', zIndex: 0 }}></div>}
            <div style={{ flexShrink: 0, width: '32px', height: '32px', borderRadius: '50%', background: COLORS.primary, color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '14px', zIndex: 1, boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
                {step}
            </div>
            <div style={{ marginLeft: '15px', flex: 1, background: 'white', padding: '15px', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.04)', border: '1px solid #f0f0f0' }}>
                <div style={{ fontWeight: 'bold', color: '#333', fontSize: '14px', marginBottom: '8px', borderBottom: '1px dashed #eee', paddingBottom: '5px' }}>{title}</div>
                <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.6' }}>
                    {children}
                </div>
            </div>
        </div>
    );

    return (
        <div className="guide-section-container" style={{ paddingBottom: '100px', fontFamily: '"Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, sans-serif' }}>
            
            <div style={{ textAlign: 'center', margin: '20px 0 30px 0' }}>
                <h2 style={{ color: '#333', margin: 0, fontSize: '22px', letterSpacing: '1px' }}>📖 アプリ利用ガイド</h2>
                <div style={{ fontSize: '12px', color: '#888', marginTop: '5px' }}>初期設定・参加から当日の流れ</div>
            </div>

            {/* ==========================================
                SECTION 1: ログイン方法とプッシュ通知
            ========================================== */}
            <div style={{ marginBottom: '40px' }}>
                <div style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', padding: '15px', borderRadius: '12px 12px 0 0', color: 'white', textAlign: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
                    <h3 style={{ margin: 0, fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                        <span>📱</span> アプリのログイン方法・通知設定
                    </h3>
                    <p style={{ margin: '8px 0 0 0', fontSize: '11px', opacity: 0.9 }}>ログイン方法は2種類！用途に合わせて使い分けてください。</p>
                </div>

                <div style={{ background: '#f8fafd', padding: '20px 15px', borderRadius: '0 0 12px 12px', border: '1px solid #e0e6ed', borderTop: 'none', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
                    
                    {/* ★追加: 2つのログイン方法の違いを明記！ */}
                    <div style={{ background: 'white', padding: '15px', borderRadius: '8px', marginBottom: '25px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', border: '1px solid #eee' }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '15px', borderBottom: '1px dashed #ddd', paddingBottom: '10px' }}>
                            <div style={{ background: '#00B900', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '4px 8px', borderRadius: '4px', flexShrink: 0 }}>LINE</div>
                            <div>
                                <div style={{ fontWeight: 'bold', fontSize: '13px', color: '#333', marginBottom: '4px' }}>LINEでログイン（通常）</div>
                                <div style={{ fontSize: '11px', color: '#666', lineHeight: '1.4' }}>LINEのトーク画面からURLを開いた時や、初めて使う方はこちら！サクッと入れます。（※プッシュ通知は届きません）</div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                            <div style={{ background: '#4285F4', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '4px 8px', borderRadius: '4px', flexShrink: 0 }}>Google</div>
                            <div>
                                <div style={{ fontWeight: 'bold', fontSize: '13px', color: '#333', marginBottom: '4px' }}>Googleでログイン（通知用・推奨✨）</div>
                                <div style={{ fontSize: '11px', color: '#666', lineHeight: '1.4' }}><b>スマホのホーム画面に追加したアイコン</b>から開く時はこちら！試合のプッシュ通知が届くようになります。（※事前の設定が必要です↓）</div>
                            </div>
                        </div>
                    </div>

                    <div style={{ textAlign: 'center', fontSize: '13px', fontWeight: 'bold', color: '#2a5298', marginBottom: '20px', borderTop: '2px dashed #bbdefb', paddingTop: '20px' }}>
                        🔔 プッシュ通知を受け取る設定手順（アプリ化）
                    </div>

                    {/* 事前準備：合鍵づくり */}
                    <div style={{ background: '#fff3e0', borderLeft: '4px solid #ff9800', padding: '15px', borderRadius: '8px', marginBottom: '25px', boxShadow: '0 2px 8px rgba(255,152,0,0.1)' }}>
                        <div style={{ color: '#e65100', fontWeight: 'bold', fontSize: '14px', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <span>🔑</span> 事前準備：合鍵づくり
                        </div>
                        <p style={{ fontSize: '12px', color: '#444', margin: '0 0 10px 0', lineHeight: '1.5' }}>
                            まずは、アプリの「マイページ」から以下の2つを設定してください。<br/>
                            <span style={{ color: '#d32f2f', fontWeight: 'bold', fontSize: '11px' }}>※必ず「半角英数字」で入力してください。</span>
                        </p>
                        <div style={{ background: 'white', padding: '10px', borderRadius: '6px', fontSize: '13px', fontWeight: 'bold', color: '#333', display: 'flex', justifyContent: 'space-around' }}>
                            <div>1️⃣ LINE ID</div>
                            <div>2️⃣ パスワード</div>
                        </div>
                        <div style={{ fontSize: '11px', color: '#666', marginTop: '8px', textAlign: 'center' }}>
                            👉 この2つが、ホーム画面からアプリを開くための「合鍵」になります！
                        </div>
                    </div>

                    {/* 手順ステップ */}
                    <StepItem step="1" title="URLを開いて「ホーム画面に追加」">
                        <div style={{ marginBottom: '10px' }}>ブラウザでアプリを開き、再度ホーム画面に追加します。（これで通知が届く最新版になります！）</div>
                        
                        {/* URLコピーツール */}
                        <div style={{ background: '#f5f5f5', padding: '10px', borderRadius: '8px', textAlign: 'center', marginBottom: '15px' }}>
                            <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#d32f2f', marginBottom: '5px' }}>⚠️ LINE内ブラウザのままでは追加できません！</div>
                            <button 
                                onClick={() => {
                                    navigator.clipboard.writeText("https://revengersblack.web.app/");
                                    alert("URLをコピーしました！\nSafariやChromeを開いて貼り付けてください。");
                                }}
                                style={{ background: 'white', color: '#2a5298', border: '1px solid #2a5298', padding: '8px 15px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 2px 5px rgba(0,0,0,0.05)' }}
                            >
                                📋 URLをコピーしてブラウザで開く
                            </button>
                        </div>

                        {/* OSタブ */}
                        <div style={{ display: 'flex', marginBottom: '15px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #ddd' }}>
                            <button onClick={() => setOsTab('ios')} style={{ flex: 1, padding: '8px', fontWeight: 'bold', fontSize: '12px', background: osTab === 'ios' ? '#2196F3' : '#f5f5f5', color: osTab === 'ios' ? 'white' : '#666', border: 'none', cursor: 'pointer', transition: '0.2s' }}>
                                🍎 iPhone の方
                            </button>
                            <button onClick={() => setOsTab('android')} style={{ flex: 1, padding: '8px', fontWeight: 'bold', fontSize: '12px', background: osTab === 'android' ? '#4CAF50' : '#f5f5f5', color: osTab === 'android' ? 'white' : '#666', border: 'none', cursor: 'pointer', transition: '0.2s' }}>
                                🤖 Android の方
                            </button>
                        </div>

                        <div style={{ background: '#fafafa', padding: '10px', borderRadius: '8px' }}>
                            {osTab === 'ios' ? (
                                <div style={{ animation: 'fadeIn 0.3s' }}>
                                    <ul style={{ margin: '0 0 10px 0', paddingLeft: '20px', fontSize: '12px' }}>
                                        <li>必ず<b>青いコンパスの「Safari」</b>でURLを開いてください。</li>
                                    </ul>
                                    {/* ★漫画画像を復活！ */}
                                    <img src="/RevengersAppNotification.jpg" alt="iPhoneアプリ化手順" style={{ width: '100%', borderRadius: '6px', border: '1px solid #eee', marginBottom: '10px' }} />
                                    
                                    {/* ★魔法の注意書き（画像との矛盾を解決！） */}
                                    <div style={{ background: '#ffebee', padding: '10px', borderRadius: '6px', border: '1px solid #ffcdd2', color: '#c62828', fontSize: '11px', lineHeight: '1.5' }}>
                                        <b>⚠️ ご注意：漫画の⑤について</b><br/>
                                        漫画の⑤で「LINEログイン」で出来ない方は、<b>「Googleでログイン(PWA用)」</b>を選んでください！
                                    </div>
                                </div>
                            ) : (
                                <div style={{ animation: 'fadeIn 0.3s' }}>
                                    <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', lineHeight: '1.8' }}>
                                        <li>必ず<b>「Chrome」ブラウザ</b>でURLを開いてください。</li>
                                        <li>画面右上のメニュー（点[⋮]が3つ）をタップします。</li>
                                        <li>メニューから<b>「ホーム画面に追加」</b>を選んで追加します。</li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </StepItem>

                    <StepItem step="2" title="新しいアイコンから起動">
                        ホーム画面に追加された新しいアイコンをタップしてアプリを開き、<b>「Googleでログイン (PWA用)」</b>のボタンを選択します。
                    </StepItem>

                    <StepItem step="3" title="Googleアカウントでサインイン">
                        ご自身のGoogleアカウント（Gmailアドレス等）を選択してログインを進めます。
                    </StepItem>

                    <StepItem step="4" title="アカウント連携（合鍵を使う！）" isLast={true}>
                        画面が変わったら、事前準備で作った<b>「LINE ID」</b>と<b>「パスワード」</b>を入力して連携完了です！🎉<br/>
                        
                        <div style={{ marginTop: '15px', background: '#e3f2fd', padding: '10px', borderRadius: '8px', borderLeft: '3px solid #2196F3' }}>
                            <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#1565c0', marginBottom: '4px' }}>💡 なぜ2回も入力するの？</div>
                            <div style={{ fontSize: '11px', color: '#555' }}>
                                手順③のGoogle画面と、手順④のアプリ画面で「2回ログイン」するような形になりますが、<b>あなたの現在のデータ（RBコインや出場記録）を、新しい通知システムと安全に紐づけるために必要な作業</b>です！ご協力をお願いします🙇‍♂️
                            </div>
                        </div>
                    </StepItem>

                    <div style={{ textAlign: 'center', marginTop: '25px' }}>
                        <button onClick={() => window.location.href = '/profile'} style={{ background: 'white', color: '#2a5298', fontWeight: 'bold', border: '2px solid #2a5298', padding: '12px 25px', fontSize: '13px', borderRadius: '25px', cursor: 'pointer', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
                            マイページで合鍵を設定する ▶︎
                        </button>
                        
                        {/* うまくいかない場合の補足注意書き */}
                        <div style={{ marginTop: '15px', fontSize: '11px', color: '#888', lineHeight: '1.6' }}>
                            ※上手くいかない人は長押しして一度、古いアイコンを削除 (※設定済みの方のみ) してください🙏
                        </div>
                    </div>

                </div>
            </div>

            {/* ==========================================
                SECTION 2: 友達紹介キャンペーン
            ========================================== */}
            <div style={{ marginBottom: '40px', background: '#fff9e6', borderRadius: '12px', border: '1px solid #ffe082', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                <div style={{ background: '#ffca28', padding: '12px', textAlign: 'center', color: '#3e2723', fontWeight: 'bold', fontSize: '15px' }}>
                    🤝 友達紹介キャンペーン！500RB GET！
                </div>
                
                <div style={{ padding: '20px 15px' }}>
                    <p style={{ fontSize: '13px', color: '#555', lineHeight: '1.6', marginBottom: '20px', textAlign: 'center' }}>
                        サッカー仲間をRevengersに招待して、<br/>
                        <b>あなたも友達もお得にポイントをゲット</b>しよう！
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', background: 'white', padding: '15px', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.02)' }}>
                            <div style={{ background: '#fff3e0', color: '#e65100', fontWeight: 'bold', borderRadius: '50%', width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>1</div>
                            <div style={{ fontSize: '13px', color: '#333', lineHeight: '1.5' }}>
                                <b>マイページから招待コードを共有！</b><br/>
                                <span style={{ color: '#777', fontSize: '11px' }}>マイページにある「招待コード」をコピーするか、LINE共有ボタンから友達に教えましょう。</span>
                            </div>
                        </div>
                        
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', background: 'white', padding: '15px', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.02)' }}>
                            <div style={{ background: '#fff3e0', color: '#e65100', fontWeight: 'bold', borderRadius: '50%', width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>2</div>
                            <div style={{ fontSize: '13px', color: '#333', lineHeight: '1.5' }}>
                                <b>友達がアプリへログイン後、招待コード記入</b><br/>
                                <span style={{ color: '#777', fontSize: '11px' }}>招待された友達がアプリに新規登録する際、プロフィール入力画面であなたの招待コードを入力します。</span>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', background: 'white', padding: '15px', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.02)' }}>
                            <div style={{ background: '#fff3e0', color: '#e65100', fontWeight: 'bold', borderRadius: '50%', width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>3</div>
                            <div style={{ fontSize: '13px', color: '#333', lineHeight: '1.5' }}>
                                <b>両者へ500RBコインが付与！ (承認制)</b><br/>
                                <span style={{ color: '#777', fontSize: '11px' }}>運営チームが確認・承認すると、あなたと友達の両方に500RBコインがプレゼントされます！🎁</span>
                            </div>
                        </div>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <button onClick={() => window.location.href = '/profile'} style={{ background: 'white', color: '#f57f17', fontWeight: 'bold', border: '2px solid #fbc02d', padding: '10px 20px', fontSize: '13px', borderRadius: '20px', cursor: 'pointer', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
                            マイページでコードを確認する ▶︎
                        </button>
                    </div>
                </div>
            </div>

            {/* ==========================================
                SECTION 3 (NEW!): ゲーム機能の遊び方
            ========================================== */}
            <h3 style={{ textAlign: 'center', color: '#333', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '20px', fontSize: '18px', marginTop: '40px' }}>🎮 ゲーム機能の遊び方 (新機能)</h3>

            <div className="guide-step-card" style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', borderLeft: `6px solid #ff9800`, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                <div className="guide-step-header" style={{ fontWeight: 'bold', fontSize: '15px', color: '#333', marginBottom: '10px' }}>
                    <span style={{ fontSize: '18px', marginRight: '8px' }}>1️⃣</span> リアル連動！ステータス育成
                </div>
                <p style={{ fontSize: '12px', color: '#666', lineHeight: '1.6', margin: 0 }}>
                    リアルの試合に参加したり、ゴール・アシスト・MOMを獲得すると、<b>翌日（深夜0時）に「ステータス振り分けポイント」が自動で付与</b>されます！<br/>
                    マイページからポイントを割り振って、自分の能力（攻撃・守備・体力・速度・技術）を強化しましょう。<br/>
                    <span style={{ color: '#d32f2f', fontWeight: 'bold', fontSize: '11px', display: 'inline-block', marginTop: '5px' }}>※一度保存して割り振ったポイントは元に戻せないので慎重に！</span>
                </p>
            </div>

            <div className="guide-step-card" style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', borderLeft: `6px solid #ffd700`, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                <div className="guide-step-header" style={{ fontWeight: 'bold', fontSize: '15px', color: '#333', marginBottom: '10px' }}>
                    <span style={{ fontSize: '18px', marginRight: '8px' }}>2️⃣</span> メンバーカードガチャ
                </div>
                <p style={{ fontSize: '12px', color: '#666', lineHeight: '1.6', margin: 0 }}>
                    ホーム画面から「RBコイン」を使ってガチャを引き、チームメンバーのカードをGET！レアリティはN〜SSRまであります。<br/>
                    カードの基礎能力は、<b>各メンバーがマイページで育成したリアルなステータス</b>がそのまま反映されます！
                </p>
            </div>

            <div className="guide-step-card" style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', borderLeft: `6px solid #2196f3`, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                <div className="guide-step-header" style={{ fontWeight: 'bold', fontSize: '15px', color: '#333', marginBottom: '10px' }}>
                    <span style={{ fontSize: '18px', marginRight: '8px' }}>3️⃣</span> 最強のスタメン編成
                </div>
                <p style={{ fontSize: '12px', color: '#666', lineHeight: '1.6', margin: 0 }}>
                    マイページの「スタメン編成」から、ガチャで引いたカードを配置して自分だけのドリームチームを作れます。<br/>
                    <b>適正ポジション以外（FWをDFに配置など）に置くと能力が大幅に下がる</b>ので注意！不要なカードはタップして「移籍（売却）」すればRBコインに還元できます。
                </p>
            </div>

            <div className="guide-step-card" style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '40px', borderLeft: `6px solid #d32f2f`, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                <div className="guide-step-header" style={{ fontWeight: 'bold', fontSize: '15px', color: '#333', marginBottom: '10px' }}>
                    <span style={{ fontSize: '18px', marginRight: '8px' }}>4️⃣</span> 🏟️ アリーナ対戦
                </div>
                <p style={{ fontSize: '12px', color: '#666', lineHeight: '1.6', margin: 0 }}>
                    ホーム画面の巨大なアリーナボタンから、他のメンバーが編成したチームとオートシミュレーション対戦ができます！<br/>
                    単なる総合力のぶつかり合いではなく、各パラメーターの相性で勝敗が決まります。勝利して報酬のRBコインをGETしましょう！
                </p>
            </div>
            
            {/* ==========================================
                SECTION 4: 参加手順 (詳細フロー)
            ========================================== */}
            <h3 style={{ textAlign: 'center', color: '#333', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '20px', fontSize: '18px' }}>⚽️ 試合当日の流れ</h3>

            {/* STEP 1: イベント参加 */}
            <div className="guide-step-card" style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                <div className="guide-step-header" style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', fontSize: '16px', marginBottom: '10px', color: '#333' }}>
                    <span className="guide-step-badge" style={{ background: COLORS.primary, color: 'white', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', marginRight: '10px' }}>1</span>
                    イベントに参加する
                </div>
                <p style={{ fontSize: '13px', color: '#666', margin: '0 0 15px 0', lineHeight: '1.5' }}>
                    ホーム画面のカレンダーまたはリストからイベントを選び、ポジションを選択してエントリーします。
                </p>

                {/* Mockup UI */}
                <div className="mock-ui-card" style={{ border: '1px solid #eee', borderRadius: '8px', overflow: 'hidden' }}>
                    <div className="mock-ui-header" style={{ background: '#f5f5f5', padding: '10px', display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                        <span style={{ fontWeight: 'bold' }}>2月4日(水) 09:00-11:00</span>
                        <span style={{ background: '#e8f5e9', color: COLORS.success, padding: '2px 6px', borderRadius: '4px', fontSize: '10px' }}>FP残8 / GK残1</span>
                    </div>
                    <div className="mock-ui-body" style={{ padding: '15px' }}>
                        <div style={{ fontSize: '12px', marginBottom: '15px', color: '#555' }}>
                            <span style={{ color: '#999', fontWeight: 'bold', marginRight: '10px' }}>会場</span>
                            <span>公園サッカー場</span>
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <div style={{ flex: 1, background: COLORS.success, color: 'white', padding: '10px', borderRadius: '6px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>FP参加</div>
                            <div style={{ flex: 1, background: COLORS.primary, color: 'white', padding: '10px', borderRadius: '6px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>GK参加</div>
                        </div>
                    </div>
                </div>

                <div className="guide-instruction" style={{ background: '#f9f9f9', padding: '10px', borderRadius: '6px', marginTop: '15px', fontSize: '11px', color: '#555' }}>
                    <strong style={{ color: '#333' }}>☝️ ポイント</strong><br />
                    定員が埋まっている場合は「キャンセル待ち」ボタンに変わります。空きが出ると自動で繰り上がります。
                </div>
            </div>

            <div className="guide-arrow-down" style={{ textAlign: 'center', color: '#ccc', fontSize: '20px', marginBottom: '20px' }}>▼</div>

            {/* STEP 2: 支払い */}
            <div className="guide-step-card" style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                <div className="guide-step-header" style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', fontSize: '16px', marginBottom: '10px', color: '#333' }}>
                    <span className="guide-step-badge" style={{ background: COLORS.primary, color: 'white', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', marginRight: '10px' }}>2</span>
                    参加費を支払う
                </div>
                <p style={{ fontSize: '13px', color: '#666', margin: '0 0 15px 0', lineHeight: '1.5' }}>
                    参加確定後、詳細画面のボタンから支払います。<br />
                    <strong style={{ color: '#d32f2f', display: 'block', margin: '5px 0' }}>【支払後に申請ください】</strong>
                    ランク特典（半額など）がある場合は自動で適用されます。
                </p>

                {/* Mockup UI: Payment */}
                <div className="mock-ui-card" style={{ padding: '15px', border: '1px solid #eee', borderRadius: '8px' }}>
                    <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#999', marginBottom: '10px' }}>参加費の支払い</div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px' }}>
                        <MockPayBtn color="#FF0033" icon="📱" label="PayPay送金" />
                        <MockPayBtn
                            color="#e65100"
                            icon={<img src="/rbcoin.png" alt="coin" style={{ width: '24px', height: '24px', objectFit: 'contain' }} />}
                            label={pointName}
                        />
                        <MockPayBtn color={COLORS.secondary} textColor="#333" icon="💴" label="当日現金" />
                    </div>
                </div>

                <ul style={{ fontSize: '12px', paddingLeft: '20px', color: '#555', lineHeight: '1.6', marginTop: '15px' }}>
                    <li><b>PayPay送金:</b> アプリが起動します。送金後、自分のPayPay IDを入力して申請してください。</li>
                    <li><b>{pointName}:</b> アプリ内通貨で即時決済完了します（推奨✨）。</li>
                    <li><b>当日現金:</b> 従来通り現地で支払う場合に使用します。</li>
                </ul>
            </div>

            <div className="guide-arrow-down" style={{ textAlign: 'center', color: '#ccc', fontSize: '20px', marginBottom: '20px' }}>▼</div>

            {/* STEP 3: チェックイン */}
            <div className="guide-step-card" style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '40px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                <div className="guide-step-header" style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', fontSize: '16px', marginBottom: '10px', color: '#333' }}>
                    <span className="guide-step-badge" style={{ background: COLORS.primary, color: 'white', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', marginRight: '10px' }}>3</span>
                    到着・チェックイン
                </div>
                <p style={{ fontSize: '13px', color: '#666', margin: '0 0 15px 0', lineHeight: '1.5' }}>
                    会場に到着したら、必ず<b>「📍 チェックイン」</b>ボタンを押してください。<br />
                    自動的にその日のチーム分け（白/黒）と番号が表示されます。
                </p>

                {/* Mockup UI: Checkin Result */}
                <div className="mock-ui-card" style={{ border: 'none', boxShadow: 'none', background: 'transparent' }}>
                    <div style={{ background: '#333', color: 'white', borderRadius: '8px', padding: '15px', textAlign: 'center', marginBottom: '15px', boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}>
                        <div style={{ fontSize: '11px', opacity: 0.8, marginBottom: '5px' }}>今日のチーム</div>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', letterSpacing: '1px' }}>⚫ 黒チーム #5</div>
                    </div>

                    <div style={{ display: 'flex', gap: '10px' }}>
                        <div style={{ flex: 1, background: 'white', border: '1px solid #ddd', borderRadius: '8px', padding: '10px' }}>
                            <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '13px', borderBottom: '1px dashed #eee', paddingBottom: '6px' }}>⚪ 白</div>
                            <div style={{ fontSize: '11px', color: '#555', marginTop: '8px', lineHeight: '1.6' }}>1. 田中<br />2. 佐藤...</div>
                        </div>
                        <div style={{ flex: 1, background: '#444', color: 'white', borderRadius: '8px', padding: '10px' }}>
                            <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '13px', borderBottom: '1px dashed #666', paddingBottom: '6px' }}>⚫ 黒</div>
                            <div style={{ fontSize: '11px', color: '#ccc', marginTop: '8px', lineHeight: '1.6' }}>1. 鈴木<br />2. 高橋...</div>
                        </div>
                    </div>
                </div>

                <div className="guide-instruction" style={{ background: '#fff3e0', borderLeft: '3px solid #ff9800', padding: '10px', borderRadius: '0 6px 6px 0', marginTop: '15px', fontSize: '11px', color: '#555' }}>
                    <strong style={{ color: '#e65100' }}>⚠️ 注意</strong><br />
                    チェックインはイベント開始時間の<b>1時間前から</b>可能です。
                </div>
            </div>

            {/* ==========================================
                SECTION 5: その他の機能解説
            ========================================== */}
            <h3 style={{ textAlign: 'center', color: '#333', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '20px', fontSize: '18px' }}>🛠 その他の機能</h3>

            {/* ランク・特典 */}
            <div className="guide-step-card" style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', borderLeft: `6px solid ${COLORS.secondary}`, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                <div className="guide-step-header" style={{ fontWeight: 'bold', fontSize: '15px', color: '#333', marginBottom: '10px' }}>
                    <span style={{ fontSize: '18px', marginRight: '8px' }}>👑</span> 会員ランクと特典
                </div>
                <p style={{ fontSize: '12px', color: '#666', lineHeight: '1.6', marginBottom: '15px' }}>
                    あなたの会員ランク（👑正規、🤝協力など）に応じて、以下の特典が自動で適用されます。
                </p>
                <ul style={{ fontSize: '12px', color: '#444', background: '#f9f9f9', padding: '12px 12px 12px 30px', borderRadius: '8px', margin: 0, lineHeight: '1.6' }}>
                    <li><b>参加費割引:</b> ランクにより無料、または半額になります。</li>
                    <li><b>優先予約:</b> 一般募集より早くイベントに参加できます。</li>
                    <li><b>参加制限:</b> 特定のイベントに参加できる権利が付与されます。</li>
                </ul>
                <div style={{ fontSize: '10px', color: '#999', marginTop: '8px', textAlign: 'right' }}>※現在のランクは「マイページ」で確認できます。</div>
            </div>

            {/* ショップ・神社 */}
            <div className="guide-step-card" style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', borderLeft: `6px solid #e65100`, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                <div className="guide-step-header" style={{ fontWeight: 'bold', fontSize: '15px', color: '#333', marginBottom: '15px' }}>
                    <span style={{ fontSize: '18px', marginRight: '8px' }}>🛒</span> ショップ・神社機能
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                        <div style={{ background: '#fff3e0', padding: '10px', borderRadius: '10px', fontSize: '18px' }}>🛒</div>
                        <div>
                            <div style={{ fontWeight: 'bold', fontSize: '13px', color: '#e65100', marginBottom: '4px' }}>ショップ</div>
                            <div style={{ fontSize: '11px', color: '#666', lineHeight: '1.5' }}>{pointName}を使って、正規メンバー権やアイテムを購入できます。</div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                        <div style={{ background: '#ffebee', padding: '10px', borderRadius: '10px', fontSize: '18px' }}>⛩️</div>
                        <div>
                            <div style={{ fontWeight: 'bold', fontSize: '13px', color: '#d32f2f', marginBottom: '4px' }}>神社 (勝守神社)</div>
                            <div style={{ fontSize: '11px', color: '#666', lineHeight: '1.5' }}>必勝祈願・厄除けができます。グラウンドや私生活で嫌なことがあったらすぐにお参りください。</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ランキング */}
            <div className="guide-step-card" style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '30px', borderLeft: `6px solid ${COLORS.primary}`, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                <div className="guide-step-header" style={{ fontWeight: 'bold', fontSize: '15px', color: '#333', marginBottom: '10px' }}>
                    <span style={{ fontSize: '18px', marginRight: '8px' }}>📊</span> 成績・ランキング
                </div>
                <p style={{ fontSize: '12px', color: '#666', lineHeight: '1.6', margin: 0 }}>
                    試合結果やMOM（マン・オブ・ザ・マッチ）、ゴール・アシスト数は全て記録されます。<br />
                    <b>マイページ</b>で自分の通算成績を確認したり、<b>ランキングタブ</b>でチーム内の順位を競い合うことができます。
                </p>
            </div>

            {/* 用語集 */}
            <div className="guide-step-card" style={{ background: '#f5f7fa', borderRadius: '12px', padding: '20px', marginBottom: '40px' }}>
                <h3 style={{ fontSize: '15px', margin: '0 0 15px 0', color: COLORS.primary, display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>💡</span> 用語集
                </h3>
                <div className="guide-glossary-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                    <TermCard title={pointName} desc="アプリ内専用通貨。事前購入やお釣りなしで便利。" />
                    <TermCard title="FP / GK" desc="FP=フィールドプレイヤー、GK=ゴールキーパー" />
                    <TermCard title="MOM" desc="マン・オブ・ザ・マッチ。試合後の投票で選出🏅" />
                    <TermCard title="ランク" desc="参加回数等でランクアップ。優先予約などの特典も。" />
                    {/* ★追加: ゲーム用の用語 */}
                    <TermCard title="ガチャ・編成" desc="コインでカードを引き、自分のドリームチームを作れます。" />
                    <TermCard title="アリーナ" desc="編成したチームで他のメンバーとオート対戦！勝つと報酬GET。" />
                </div>
            </div>

            {/* ==========================================
                SECTION 6: イベント画面の見方 (図解)
            ========================================== */}
            <div className="guide-step-card" style={{ background: 'white', borderRadius: '12px', padding: '20px', borderTop: `6px solid ${COLORS.primary}`, boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
                <div className="guide-step-header" style={{ fontWeight: 'bold', fontSize: '16px', color: '#333', marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <span style={{ fontSize: '20px', marginRight: '8px' }}>🔍</span> イベント画面の見方
                </div>
                <p style={{ fontSize: '12px', color: '#666', marginBottom: '20px' }}>
                    イベント詳細画面の各項目の説明です。
                </p>

                {/* --- 図解用モックアップ --- */}
                <div className="mock-ui-card" style={{ position: 'relative', overflow: 'visible', border: '1px solid #ddd', borderRadius: '10px' }}>
                    <div className="mock-ui-header" style={{ flexDirection: 'column', alignItems: 'stretch', background: '#fafafa', padding: '15px', borderBottom: '1px solid #eee' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                <Marker num="1" /> 2/4(水) <Marker num="2" /> 09:00-11:00
                            </div>
                            <span style={{ background: '#e8f5e9', color: COLORS.success, padding: '4px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: 'bold' }}>
                                <Marker num="4" /> 残あり
                            </span>
                        </div>
                        <div style={{ fontSize: '12px', display: 'flex', justifyContent: 'space-between', color: '#555' }}>
                            <span><Marker num="3" /> 公園サッカー場</span>
                            <span style={{ color: COLORS.primary }}>📅 <Marker num="5" /></span>
                        </div>
                    </div>

                    <div className="mock-ui-body" style={{ padding: '15px' }}>
                        <div style={{ background: '#f9f9f9', padding: '12px', borderRadius: '8px', marginBottom: '15px', border: '1px solid #eee' }}>
                            <div style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '13px' }}>
                                <Marker num="6" /> VS FC仮
                            </div>
                            <div style={{ fontSize: '12px', color: '#555', marginBottom: '8px' }}>
                                👕 自:<Marker num="7" />白 / 敵:<Marker num="8" />虹
                            </div>
                            <div style={{ fontSize: '13px', color: '#333', marginBottom: '10px', fontWeight: 'bold' }}>
                                <Marker num="9" /> 参加費: ¥500
                            </div>
                            <div style={{ fontSize: '11px', color: '#d32f2f', background: '#fff', padding: '6px', border: '1px dashed #d32f2f', borderRadius: '4px', marginBottom: '6px' }}>
                                <Marker num="10" /> 注意事項：15分前集合...
                            </div>
                            <div style={{ fontSize: '11px', color: '#0277bd', background: '#e1f5fe', padding: '6px', borderRadius: '4px' }}>
                                <Marker num="11" /> 持ち物：スパイク可...
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '8px', marginBottom: '15px' }}>
                            <button style={{ flex: 1, background: COLORS.success, color: 'white', border: 'none', borderRadius: '6px', padding: '10px', fontSize: '12px', fontWeight: 'bold' }}>
                                <Marker num="12" /> FP参加
                            </button>
                            <button style={{ flex: 1, background: COLORS.primary, color: 'white', border: 'none', borderRadius: '6px', padding: '10px', fontSize: '12px', fontWeight: 'bold' }}>
                                GK参加
                            </button>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '15px' }}>
                            <div style={{ background: '#f5f5f5', padding: '8px', textAlign: 'center', border: '1px solid #ddd', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', color: '#555' }}>
                                <Marker num="15" /> 支払い
                            </div>
                            <div style={{ background: '#e8f5e9', padding: '8px', textAlign: 'center', border: '1px solid #a5d6a7', borderRadius: '6px', color: COLORS.success, fontWeight: 'bold', fontSize: '12px' }}>
                                <Marker num="16" /> チェックイン
                            </div>
                        </div>

                        <div style={{ fontSize: '12px', borderTop: '1px solid #eee', paddingTop: '10px', color: '#555' }}>
                            <div style={{ marginBottom: '8px' }}>✅ <Marker num="13" /> 参加メンバー (一覧)</div>
                            <div>💬 <Marker num="14" /> 連絡ボード (遅刻連絡など)</div>
                        </div>

                        <div style={{ textAlign: 'center', marginTop: '15px' }}>
                            <span style={{ fontSize: '11px', textDecoration: 'underline', color: '#999' }}><Marker num="17" /> キャンセルはこちら</span>
                        </div>
                    </div>
                </div>

                {/* 凡例リスト */}
                <div style={{ background: '#fcfcfc', padding: '15px', borderRadius: '8px', marginTop: '15px', border: '1px solid #f0f0f0' }}>
                    <ul className="guide-legend-list" style={{ margin: 0, padding: 0, listStyle: 'none', display: 'grid', gridTemplateColumns: '1fr', gap: '8px' }}>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="1" /></div> 日時・日付</li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="2" /></div> 開催時間</li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="3" /></div> 会場名 <span style={{ color: '#999', fontSize: '9px', marginLeft: '5px' }}>(タップでGoogleMap起動)</span></li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="4" /></div> 募集状況 <span style={{ color: '#999', fontSize: '9px', marginLeft: '5px' }}>(残枠数 / キャンセル待ち)</span></li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="5" /></div> カレンダー登録</li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="6" /></div> 対戦相手</li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="7" /></div> 自チームのユニフォーム色</li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="8" /></div> 相手チームのユニフォーム色</li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="9" /></div> 参加費 <span style={{ color: '#999', fontSize: '9px', marginLeft: '5px' }}>(FP/GKで異なる場合あり)</span></li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="10" /></div> 注意事項 <span style={{ color: '#999', fontSize: '9px', marginLeft: '5px' }}>(雨天判断、免責事項など)</span></li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="11" /></div> 持ち物 (スパイク可否など)</li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="12" /></div> 参加ボタン <span style={{ color: '#999', fontSize: '9px', marginLeft: '5px' }}>(FP/GK)</span></li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="13" /></div> 現在の参加メンバー一覧</li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="14" /></div> 連絡ボード (遅刻等の連絡)</li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="15" /></div> 参加費の支払い</li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="16" /></div> 到着チェックイン</li>
                        <li className="guide-legend-item" style={{ fontSize: '11px', color: '#444', display: 'flex', alignItems: 'center' }}><div style={{ width: '24px' }}><Marker num="17" /></div> 参加キャンセル</li>
                    </ul>
                </div>
            </div>

        </div>
    );
};

// --- サブコンポーネント ---

const MockPayBtn = ({ color, textColor = 'white', icon, label }) => (
    <div style={{
        background: color,
        color: textColor,
        padding: '10px 4px',
        borderRadius: '8px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.75rem',
        cursor: 'default',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
        <div style={{ fontSize: '1.2rem', marginBottom: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px' }}>
            {icon}
        </div>
        <div style={{ fontWeight: 'bold', fontSize: '0.7rem' }}>{label}</div>
    </div>
);

const TermCard = ({ title, desc }) => (
    <div className="guide-term-card" style={{ background: 'white', padding: '12px', borderRadius: '8px', border: '1px solid #eee', boxShadow: '0 2px 5px rgba(0,0,0,0.02)' }}>
        <span style={{ display: 'block', fontWeight: 'bold', color: COLORS.primary, marginBottom: '6px', fontSize: '13px' }}>{title}</span>
        <span style={{ fontSize: '11px', color: '#666', lineHeight: '1.5', display: 'block' }}>{desc}</span>
    </div>
);

export default GuideSection;